export const isMenuItemActive = (url: string) => new RegExp(`(${url})(.)?`).test(window.location.pathname);
